import { Box } from "@mui/material";
import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";

import { useAuth } from "@/contexts/AuthContext";
import { redirectUnauthorizedBestiesAccess } from "@/features/BestiesOnboarding/access";
import { BestiesHeader } from "@/features/BestiesOnboarding/components/BestiesHeader";

export const Route = createFileRoute("/_auth/besties/$siteId")({
  beforeLoad: ({ context, params }) => {
    redirectUnauthorizedBestiesAccess(
      context.auth?.user?.user?.role,
      params.siteId,
      context.auth?.user?.org_type,
    );
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { siteId } = Route.useParams();
  const { user } = useAuth();
  const location = useLocation();

  const agencyName = user?.org_name?.trim() || "Agency";
  const isBrandSetup = /\/onboarding\/[^/]+/.test(location.pathname);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: "100%",
      }}
    >
      <BestiesHeader
        siteId={siteId}
        isBrandSetup={isBrandSetup}
        agencyName={agencyName}
      />
      <Outlet />
    </Box>
  );
}
